import { render, staticRenderFns } from "./MaterialityFAQ.vue?vue&type=template&id=54a9f36e&scoped=true"
import script from "./MaterialityFAQ.vue?vue&type=script&lang=js"
export * from "./MaterialityFAQ.vue?vue&type=script&lang=js"
import style0 from "./MaterialityFAQ.vue?vue&type=style&index=0&id=54a9f36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9f36e",
  null
  
)

export default component.exports